<div class="w-full">
    <ng-content select="vsf-layout-header"></ng-content>
</div>
<div class="w-full min-h-screen">
    <ng-content></ng-content>
</div>
<div class="w-full">
    <ng-content select="vsf-layout-footer"></ng-content>
</div>
